import { playSound } from './sounds';

export const NOTIFICATION_KEY = 'mk_notifications';

export function getNotifications() {
  try {
    const raw = JSON.parse(localStorage.getItem(NOTIFICATION_KEY) || '[]');
    return Array.isArray(raw) ? raw : [];
  } catch { return []; }
}

export function saveNotifications(items) {
  localStorage.setItem(NOTIFICATION_KEY, JSON.stringify(items.slice(0, 50)));
  window.dispatchEvent(new CustomEvent('mk-notifications-changed'));
}

export function addNotification(title, message, type = 'info') {
  const normalizedTitle = String(title || '').toLowerCase();
  if (normalizedTitle.includes('order placed') || normalizedTitle.includes('order success')) playSound('orderSuccess');
  else if (normalizedTitle.includes('order failed') || normalizedTitle.includes('order rejected')) playSound('orderFailure');
  const items = getNotifications();
  items.unshift({ id: `${Date.now()}-${Math.random().toString(36).slice(2,7)}`, title, message, type, read: false, createdAt: new Date().toISOString() });
  saveNotifications(items);
}
